var cov_m6qj482mp = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Upload/index.ts",
      hash = "422deaea2e38d7124012b3c9cdf480b569b29982",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Upload/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 9,
          column: 21
        },
        end: {
          line: 9,
          column: 38
        }
      },
      "1": {
        start: {
          line: 10,
          column: 0
        },
        end: {
          line: 10,
          column: 32
        }
      },
      "2": {
        start: {
          line: 11,
          column: 0
        },
        end: {
          line: 11,
          column: 30
        }
      },
      "3": {
        start: {
          line: 12,
          column: 0
        },
        end: {
          line: 12,
          column: 36
        }
      },
      "4": {
        start: {
          line: 13,
          column: 0
        },
        end: {
          line: 13,
          column: 35
        }
      },
      "5": {
        start: {
          line: 15,
          column: 0
        },
        end: {
          line: 15,
          column: 38
        }
      },
      "6": {
        start: {
          line: 17,
          column: 0
        },
        end: {
          line: 17,
          column: 49
        }
      },
      "7": {
        start: {
          line: 18,
          column: 0
        },
        end: {
          line: 18,
          column: 51
        }
      },
      "8": {
        start: {
          line: 19,
          column: 0
        },
        end: {
          line: 19,
          column: 53
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import inputable from '../Form/inputable';
import Upload from './Upload';
import Image, { Handler } from './Image';
import Progress from './Progress';
import Dragger from './Dragger';
import { consumer } from './context';
var exports = (cov_m6qj482mp.s[0]++, inputable(Upload));
cov_m6qj482mp.s[1]++;
exports.Image = inputable(Image);
cov_m6qj482mp.s[2]++;
exports.ImageHandler = Handler;
cov_m6qj482mp.s[3]++;
exports.Button = inputable(Progress);
cov_m6qj482mp.s[4]++;
exports.Dragger = consumer(Dragger);
cov_m6qj482mp.s[5]++;
exports.displayName = 'ShineoutUpload';
cov_m6qj482mp.s[6]++;
exports.Image.displayName = 'ShineoutImageUpload';
cov_m6qj482mp.s[7]++;
exports.Button.displayName = 'ShineoutButtonUpload';
cov_m6qj482mp.s[8]++;
exports.Dragger.displayName = 'ShineoutDraggerUpload';
export default exports;